import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bar" }
const _hoisted_2 = {
  key: 0,
  class: "event"
}
const _hoisted_3 = { class: "event-message" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-check-circle" }, null, -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, null, -1)
const _hoisted_8 = { class: "col-md-6 text-right" }
const _hoisted_9 = { class: "menu-item" }
const _hoisted_10 = { class: "menu-item" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "menu-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      ($data.event.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.$t($data.event.message)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", {
            class: "product-name",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.home()))
          }, "API")
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$session.user.name), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("select", {
              class: "form-control customer-select",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.selectedCustomer.idCustomer) = $event)),
              onChange: _cache[2] || (_cache[2] = ($event: any) => ($options.changeCustomer($data.selectedCustomer.idCustomer)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$session.customers, (customer) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: customer.idCustomer,
                  value: customer.idCustomer
                }, _toDisplayString(customer.name), 9, _hoisted_11))
              }), 128))
            ], 544), [
              [_vModelSelect, $data.selectedCustomer.idCustomer]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn btn-info",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.logout())),
              translate: ""
            }, "Logout")
          ])
        ])
      ])
    ])
  ]))
}